import BaseItem from '../base_item';
import {Mover} from '../../../states/mover';


export default class BaseMoveableItem extends BaseItem {
    constructor(x, y, frame, key) {
        super(x,y,frame,key);
        this.shadow.destroy()
        this.shadow = game.add.sprite(0, (this.height / 2) - 5, "actors", "shadow.png");
        this.shadow.width = this.width;
        this.addChild(this.shadow);
        this.shadow.anchor.set(0.5, 0.5);

        this.mover = new Mover(this, game.graph);
        this.setWalking();
    }

    get movingSpeed() { return 30;}

    get movable() { return true; }

    update() {
        if (!game.gameState.canUpdateItem()) return;
        if (this.wasWalking && !this.walking) {
            this.mover.stop();
        }
        super.update();
        if (this.walking) {
            this.mover.update()
        }
        this.wasWalking = this.walking;
    }

    get centerPoint() {
        return {
            x: this.centerX,
            y: this.bottom
        }
    }


    resetStateAfterFly() {
        super.resetStateAfterFly();
        this.setWalking();
    }
}


// WEBPACK FOOTER //
// ./src/objects/items/moveable/base_moveable_item.js